// config
import sourceShortcuts from "../../config/sourceShortcuts";
import {setDatasets} from "../../components/charts/helpers";

export default {
  computed: {
    showZeroData() {
      return this.$store.getters.getZeroData(this.chartName);
    },
    dataBarCollection() {
      if (Object.keys(this.data).length) {
        return {
          labels: this.getLabels(),
          datasets: this.getDataSets(),
          databylables: this.getDataByLables()
        };
      }

      return {};
    }
  },
  methods: {
    getTotal(elem) {
      return elem.total.reduce((sum, elem) => {
        return sum + elem[1];
      }, 0);
    },
    getDataBySource(tonal) {
      let sum = [];

      Object.entries(sourceShortcuts).forEach(item => {
        if (this.socialList.includes(item[0])) {
          if (this.data[item[0]]){

            if (this.showZeroData) {
              sum.push(this.data[item[0]][tonal].reduce((sum, elem) => {
                return sum + elem[1];
              }, 0));
            } else {
              if(this.getTotal(this.data[item[0]])) {
                sum.push(this.data[item[0]][tonal].reduce((sum, elem) => {
                  return sum + elem[1];
                }, 0));
              }
            }
          }
        }
      });

      return sum;
    },
    getDataSets() {
      return [
        {
          label: this.$t('feed.analytics.publications.body.tonal[0].title'),
          position: "top",
          backgroundColor: "#b3bccc",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.getDataBySource("netural"),
          showLabel: this.showLabel,
        },
        {
          label: this.$t('feed.analytics.publications.body.tonal[1].title'),
          position: "bottom",
          backgroundColor: "#f75b5b",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.getDataBySource("negative"),
          showLabel: this.showLabel,
        },
        {
          label: this.$t('feed.analytics.publications.body.tonal[2].title'),
          position: "top",
          backgroundColor: "#15cf49",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.getDataBySource("positive"),
          showLabel: this.showLabel,
        }
      ];
    },
    getLabels() {
      let sourceShortcuts = this.$t('feed.analytics.publications.body.shortcuts');

      return Object.entries(sourceShortcuts).reduce((arr, elem) => {
        if (this.socialList.includes(elem[0])) {
          if (this.data[elem[0]]) {
            if (this.showZeroData) {
              arr.push(elem[1]);
            } else {
              if(this.getTotal(this.data[elem[0]])) {
                arr.push(elem[1]);
              }
            }
          }
        }
        return arr;
      }, []);
    },
    getSocial(it) {
      let socArr = {
        vk: "Вконтакте",
        dz: "Блоги",
        fb: "Facebook",
        ok: "Одноклассники",
        tw: "Twitter",
        ig: "Инстаграм",
        tg: "Telegram",
        yt: 'Youtube',
        gs: 'СМИ'
      }
      return socArr[it]
    },
    getSum(arr) {
      let sum = 0
      arr.forEach((it) => {
        sum += it[1];
      });
      return sum;
    },
    getDataByLables() {
      console.log("!!!",this.data)
      let arr = []
      for (let key in this.data) {
        if (key !="total")
          arr.push({
            category: this.getSocial(key),
            negative: this.getSum(this.data[key].negative),
            positive: this.getSum(this.data[key].positive),
            netural: this.getSum(this.data[key].netural),
            total: this.getSum(this.data[key].total),
          })
      }
      return arr
    }
  },
  data() {
    return {
      endTime: '23:59:59',
      barOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              padding: 10,
              pointStyle: "dote",
              fontSize: 10,
              fontFamily: "Roboto",
              fontStyle: "bold",
              fontColor: "rgb(179,188,204)",
              beginAtZero: true,
              callback: function(value, index, values) {
                if (Math.floor(value) === value) {
                  return value;
                }
              }
            },
            gridLines: {
              color: "rgb(179,188,204)",
              drawOnChartArea: false,
            }
          }],
          yAxes: [{
            barPercentage: 0.5,
            categoryPercentage: 0.3,
            stacked: true,
            ticks: {
              padding: 50,
              beginAtZero: true
            },
            gridLines: {
              color: "rgba(0, 0, 0, 0)",
            }
          }],
        },
        legend: {
          display: false,
        },
        plugins: {
          datalabels: {
            display: (ctx) => {
              return ctx.dataset.showLabel;
            },
            color: (ctx) => {
              return ctx.dataset.backgroundColor;
            },
            formatter: function(value, ctx) {
              if (value === 0) {
                return "";
              }
              const datasets = setDatasets(ctx);
              let sum = 0;

              datasets.forEach(item => {
                sum += item.data[ctx.dataIndex];
              });

              if(((value / sum) * 100) === 0) {
                return "";
              }

              const byModule =  ((value / sum) * 100) % 1;
              const quotient = value / sum;

              if(!byModule) {

                if(isNaN(quotient)) {
                  return  "";
                }

                return `${(quotient * 100).toFixed(0)}%`;
              }

              return  `${(quotient * 100).toFixed(2)}%`;
            },
            anchor: "center",
            offset: (ctx) => {
              return ctx.dataset.data.length === 1 ? 15 : 7;
            },
            align: (ctx) => {
              return ctx.dataset.position;
            },
            font: {
              weight: "bold",
              size: 10,
              family: "Roboto"
            }
          },
        },
        tooltips: {
          backgroundColor: '#ffffff',
          titleFontFamily: "Roboto",
          titleFontStyle: "normal",
          titleFontColor: "#5E6D82",
          bodyFontFamily: "Roboto",
          bodyFontColor: "#5E6D82",
          borderColor: "#b3bccc",
          borderWidth: 1
        },
        hover: {mode: null},
      },
    };
  },
};
